import { useEffect, useRef } from 'react';
import { Timeout } from 'shared/types';

import { sendViewOfferActivity } from '../api';
import { OffersSessionStorage } from '../storage';

interface UseViewActivitySenderArgs {
    enteredViewport?: boolean;
    offerToken: string;
    orderId: string;
    delay?: number;
    disabled?: boolean;
}

const DEFAULT_DELAY = 2000;

export function useViewActivitySender(args: UseViewActivitySenderArgs) {
    const {
        orderId,
        offerToken,
        enteredViewport,
        delay = DEFAULT_DELAY,
        disabled
    } = args;

    const timeoutRef = useRef<Timeout | null>(null);

    const viewedOfferTokens = OffersSessionStorage.getInstance().getViewedOfferTokens();

    const isActivitySent = viewedOfferTokens.includes(offerToken);

    useEffect(function scheduleViewActivitySending() {
        if (isActivitySent || disabled) {
            return;
        }

        if (!enteredViewport || timeoutRef.current) {
            return;
        }


        timeoutRef.current = setTimeout(() => {
            sendViewOfferActivity(orderId).then(() => {
                OffersSessionStorage.getInstance().addViewedOffer(offerToken);
            });
        }, delay);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [ isActivitySent, offerToken, enteredViewport, delay, orderId, disabled ]);

    useEffect(function cancelViewActivitySending() {
        if (enteredViewport || !timeoutRef.current) {
            return;
        }

        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
    }, [ enteredViewport ]);
}
